import { getContrast } from 'color2k';

let customTextColors: { [color: string]: 'black' | 'white' } = {};

/**
 * Define custom text color when automatic black/white isn't sufficient.
 *
 * Useful to override the default text color automation (that uses TEXT_LUMINANCE_THRESHOLD)
 * and forego useability standards for aeshetics.
 */
export const defineCustomTextColors = (textColorPairs: { [color: string]: 'black' | 'white' }) => {
	customTextColors = {
		...customTextColors,
		...textColorPairs,
	};
};

const BACKGROUND_COLOR_REGEX = /^#......00$/;

export const getTextColor = (backgroundColor?: string) => {
	if (!backgroundColor || ['transparent', 'none'].includes(backgroundColor) || BACKGROUND_COLOR_REGEX.test(backgroundColor)) {
		return 'var(--color-black)';
	}

	if (typeof customTextColors[backgroundColor] === 'string') {
		return customTextColors[backgroundColor] === 'black' ? 'var(--color-black)' : 'var(--color-white)';
	}

	// This used to pipe into the themes to get the value of black and white, but it turns out black is always black,
	// and white is always white, so it's just... I mean, it's... I swear I had something for this.
	return getContrast(backgroundColor, '#000000') > getContrast(backgroundColor, '#ffffff') ? 'var(--color-black)' : 'var(--color-white)';
};
